// removed by extract-text-webpack-plugin
module.exports = {"alert":"alert-2nFS0","text":"text-3Bf09"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/alert-dialog/style.scss
 ** module id = 19
 ** module chunks = 0
 **/